import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

export const OtpSecurityBadge = () => (
  <div className="border-primary flex w-fit items-center gap-1 rounded-md border px-2 py-1">
    <Icon name="lock" size="sm" color="tertiary" />
    <span className="leading-[18px] tracking-[0.2px]">
      <Typography.LabelXs color="text-tertiary" weight="font-medium">
        {t("otp_challenge_modal.safe_and_secure")}
      </Typography.LabelXs>
    </span>
  </div>
);

OtpSecurityBadge.displayName = "OtpSecurityBadge";
